import React from 'react';
import {MasterLayout} from 'layout';
import { connect } from 'react-redux';
import { header } from 'constants/table';
import { browserHistory } from 'react-router';
import {TrangChu} from 'api';
import classNames from 'classnames/bind';
import DataTable from 'components/data-table';
import { Input, DropDown, DropDownMultipleSelect, DropDownTreeMultipleSelect } from 'components/tt-forms/common';
import {
  DropDownChonLoaiDonThu,
  DropDownChonLinhVucDonThu,
  DropDownChonLinhVucDonThuChiTiet,
  DropDownChonNguonDon,
  DropDownKetQuaGiaiQuyet
} from 'components/tt-forms';
import RowItemKetQuaTraCuu from './RowItemKetQuaTraCuu.jsx';

class GiamSatTraCuu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: '',
      phamVi: 'ALL',
      hoTen: '',
      diaChi: '',
      maDon: '',
      linhVucId: '',
      phanLoaiDon: '',
      linhVucChiTietId: '',
      nguonDon:'',
      data: [],
      loading: false,
      donViTiepNhanData: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      firstLoad: false
    }
  }

  componentDidMount() {
    let arrData = [...this.state.donViTiepNhanData];
    this.props.dvTiepNhanList.forEach((item) => {
      arrData.push(item);
    });
    let data = localStorage.getItem('tcData') ? JSON.parse(localStorage.getItem('tcData')) : {};
    this.setState({
      donViTiepNhanData: arrData,
      pageData: {
        number: data.page || 0,
        size: data.size || 10,
      },
      maDon: data.maDon || data.maVuViec || '',
      hoTen: data.hoTen || data.tenNguoiKhieuNai || '',
      soDinhDanhCaNhan: data.soDinhDanhCaNhan || '',
      maTinh: data.maTinh || '',
      maHuyen: data.maHuyen || '',
      maXa: data.maXa || '',
      noiDung: data.noiDung || '',
      diaChi: data.diaChi || '',
      listDonViTiepNhan: data.listDVTN && data.listDVTN.length ? data.listDVTN : [],
      phanLoaiDon: data.phanLoaiDon || '',
      linhVucId: data.linhVucId || '',
      linhVucChiTietId: data.linhVucChiTietId || '',
      nguonDon: data.nguonDon || ''
    }, () => {
      if (Object.keys(data).length > 1) {
        this.handleSearch();
      }
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.handleSearch();
  }

  handleChangePageSize(size) {
    this.state.pageData.number = 0;
    this.state.pageData.size = size;
    this.handleSearch();
  }

  handleSearch(isFirst) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (isFirst) {
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
    }
    let params = {
      taiDonVi: userInfo.donViChaId ? true : false,
      page: this.state.pageData.number,
      size: this.state.pageData.size
    };
    if (this.state.maDon) {
      params.maDon = this.state.maDon.trim();
    }
    if (this.state.hoTen) {
      params.hoTen = this.state.hoTen.trim();
    }
    if (this.state.diaChi) {
      params.diaChi = this.state.diaChi.trim();
    }
    if (this.state.listDonViTiepNhan && this.state.listDonViTiepNhan.length) {
      const strId = this.state.listDonViTiepNhan.map(item => item.value);
      params.listDonViTiepNhan = strId.join();
      // params.listDVTN = this.state.listDonViTiepNhan;
    }
    if (this.state.phanLoaiDon) {
      params.phanLoaiDon = this.state.phanLoaiDon;
    }
    if (this.state.linhVucId) {
      params.linhVucId = this.state.linhVucId;
    }
    if (this.state.linhVucChiTietId) {
      params.linhVucChiTietId = this.state.linhVucChiTietId;
    }
    if (this.state.nguonDon) {
      params.nguonDon = this.state.nguonDon;
    }
    this.setState({loading: true});
    localStorage.setItem('tcData', JSON.stringify(params));
    TrangChu.actions.getTraCuuDonCanBo.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ data : res.data._embedded.medial_DonTraCuus });
      } else {
        this.setState({ data : [] });
      }
      this.setState({
        loading: false,
        pageData : res.data.page,
        firstLoad: true
      });
    }).catch(error => {
      this.setState({
        data : [],
        pageData : {
          number: 0,
          size: 10,
          totalElements: 0
        },
        firstLoad: true,
        loading: false
      });
    });
  }

  onChange(name, e) {
    if (name == 'listDonViTiepNhan') {
      this.setState({listDonViTiepNhan: e});
    } else {
      if (name == 'phanLoaiDon') {
        this.setState({linhVucId: '', linhVucChiTietId: ''});
      }
      if (name == 'maTinh' || name == 'maHuyen') {
        this.setState({maXa: '' });
        if (name == 'maTinh') {
          this.setState({maHuyen: ''});
        }
      }
      this.setState({[name]: e.target.value});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dvTiepNhanList !== this.props.dvTiepNhanList) {
      let arrData = [];
      nextProps.dvTiepNhanList.forEach((item) => {
        arrData.push(item);
      });
      this.setState({donViTiepNhanData: arrData});
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name} type={this.props.route.type}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="heading" style={{marginBottom: '0px'}}>
              <h2 className="heading-title icon-search" style={{display:'inline-block', marginRight: '40px'}}>Giám sát tra cứu</h2>
            </div>
          </div>
          <div className="bottom-content">
            <form onSubmit={this.handleSearch.bind(this, true)} action="javascript:void(0)" noValidate>
              <div className="search-container super-search">
                <Input label="Mã đơn" name="maDon" placeholder="Nhập..." value={this.state.maDon} onChange={this.onChange.bind(this, 'maDon')} className="input-group" />
                <Input label="Tên người đứng đơn" name="hoTen" placeholder="Nhập..." value={this.state.hoTen} onChange={this.onChange.bind(this, 'hoTen')} className="input-group" maxLength={255} />
                <Input label="Địa chỉ" placeholder="Nhập..." name="diaChi" value={this.state.diaChi} onChange={this.onChange.bind(this, 'diaChi')} className="input-group" />
                <DropDownTreeMultipleSelect className="input-group tree-selected" label="Địa bàn (Đơn vị) tiếp nhận" dataOptions={this.state.donViTiepNhanData} dataSelected={this.state.listDonViTiepNhan} onChange={this.onChange.bind(this, 'listDonViTiepNhan')} selectAllChildren={false} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
                <DropDownChonLoaiDonThu selectedValue={this.state.phanLoaiDon}  className="input-group" label="Loại đơn" onChange={this.onChange.bind(this, 'phanLoaiDon')} name="dropdownChonLoaiDonThu" isTraCuu={true}/>
                <DropDownChonLinhVucDonThu selectedValue={this.state.linhVucId} allowHidden={false} className="input-group" label="Lĩnh vực" loaiDonThuID={this.state.phanLoaiDon} onChange={this.onChange.bind(this, 'linhVucId')} name="dropdownChonLinhVucDonThu"/>
                <DropDownChonLinhVucDonThuChiTiet label="Lĩnh vực chi tiết (nếu có)" allowHidden={false} className="input-group" loaiDonThuID={this.state.phanLoaiDon} selectedValue={this.state.linhVucChiTietId} linhVucDonThuID={this.state.linhVucId} onChange={this.onChange.bind(this, 'linhVucChiTietId')} name="dropdownChonLinhVucCap2Id"/>
                <DropDownChonNguonDon
                  selectedValue={this.state.nguonDon}
                  onChange={this.onChange.bind(this, 'nguonDon')}
                  className="input-group"/>
              </div>
              <div className="search-container super-search" style={{paddingBottom: '18px', paddingLeft: '20px', paddingRight: '20px'}}>
                <button type="submit" className={classNames('pt-button btn-green tt-search', {'btn-loading-inline': this.state.loading})}><span>Xem kết quả</span></button>
              </div>
            </form>
            {
              ((this.state.data && this.state.data.length) || this.state.firstLoad) &&
              <DataTable header={header.listTraCuuDon}
                dataList={this.state.data}
                hideButtonExport={true}
                pageData={this.state.pageData}
                parent={this}
                displayCount={true}
                tableLoading={this.state.loading}>
                <RowItemKetQuaTraCuu phamVi={this.state.phamVi}/>
              </DataTable>
            }
          </div>
        </div>
      </MasterLayout>
    );
  }
}

GiamSatTraCuu.defaultProps = {
  dvTiepNhanList: []
}

function bindStateToProps(state) {
  return {
    dvTiepNhanList: state.duLieuHeThong.diaBanTiepNhan
  };
}
export default connect(bindStateToProps)(GiamSatTraCuu);


// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/GiamSatTraCuu.jsx